import { render, staticRenderFns } from "./user-profile-form.vue?vue&type=template&id=e70e1f58&lang=pug&"
import script from "./user-profile-form.vue?vue&type=script&lang=js&"
export * from "./user-profile-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports